import axios from 'axios'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const settlementCsvDownload = (tokens: any, reqBody: any, fileName: string) => {
  return axios
    .post(`${sitConfig(tokens).baseUrl}${APIEndPoints.SettlementCSVDownload}${fileName}`, reqBody, {
      headers: sitConfig(tokens).headers,
      responseType: 'blob',
    })
    .then((resp) => {
      return responseParser(resp)
    })
}

export { settlementCsvDownload }
